import { http } from "@next-core/http";
/**
 * @description 获取elevo会话列表
 * @endpoint GET /api/v1/elevo/conversations
 */
export const ElevoApi_listElevoConversations = async (params, options) => /**! @contract easyops.api.llm.elevo.ListElevoConversations@1.0.0 */(await http.get("api/gateway/logic.llm.aiops_service/api/v1/elevo/conversations", {
  ...options,
  params
})).data;
//# sourceMappingURL=listElevoConversations.js.map